import { clearRecentSearches, loadRecentSearches, saveRecentSearch, } from "../storage/recentSearches";
import { useState } from "react";
export function useRecentSearches() {
    const [recent, setRecent] = useState(() => loadRecentSearches());
    function clearRecent() {
        clearRecentSearches();
        setRecent([]);
    }
    function addRecent(item) {
        setRecent(saveRecentSearch(item));
    }
    return { recent, clearRecent, addRecent };
}
